import {combineLatest as observableCombineLatest, of as observableOf, Observable} from 'rxjs';

import {map} from 'rxjs/operators';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {AbstractControlReadonlyComponent} from './abstract-control-readonly';
import {ViewTabComponent} from '../viewtab.component';
import {ErrorService} from '../../../error/error.service';

@Component({
  selector: 'ctrl-picturebox',
  template: `
    @if (source | async) {
      <img
        class="rounded"
        [src]="source | async"
        [alt]="alternateText | async"
        [style.max-width.px]="maxWidth | async"
        [style.max-height.px]="maxHeight | async"
      />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CtrlPictureBoxComponent extends AbstractControlReadonlyComponent {
  source: Observable<string> = null;
  private alternateText: Observable<string> = observableOf('');
  private maxWidth: Observable<number> = null;
  private maxHeight: Observable<number> = null;

  constructor(
    parent: ViewTabComponent,
    changeDetector: ChangeDetectorRef,
    errorService: ErrorService,
  ) {
    super(parent, null, changeDetector, errorService);
  }

  protected initSource(): void {}

  protected initMain(): void {
    this.source = this.getCaughtObservable(
      observableCombineLatest(
        this._config.getPropertyValues('ImageData'),
        this._config.getPropertyValues('ImageResource'),
        this._config.getPropertyValues('ImageUrl'),
        (data: string, resource: string, url: string) => {
          if (data != null) {
            return 'data:image/jpg;base64,' + data;
          } else if (resource != null) {
            return 'data:image/jpg;base64,' + resource;
          } else if (url != null && !url.startsWith('~/')) {
            if (url.startsWith('http://') || url.startsWith('https://')) {
              return url;
            } else {
              return 'layoutAssets/' + url;
            }
          } else {
            return null;
          }
        },
      ),
    );

    if (this._config.propertyExists('MaxHeight')) {
      this.maxHeight = this.getCaughtObservable(
        this._config.getPropertyValues('MaxHeight').pipe(map(v => (v ? Number(v) : null))),
      );
    }

    if (this._config.propertyExists('MaxWidth')) {
      this.maxWidth = this.getCaughtObservable(
        this._config.getPropertyValues('MaxWidth').pipe(map(v => (v ? Number(v) : null))),
      );
    }

    if (this._config.propertyExists('AlternativeText')) {
      this.alternateText = this.getCaughtObservable(
        this._config.getPropertyValues('AlternativeText').pipe(map(v => (v ? v : ''))),
      );
    } else if (this._config.propertyExists('AlternateText')) {
      this.alternateText = this.getCaughtObservable(
        this._config.getPropertyValues('AlternateText').pipe(map(v => (v ? v : ''))),
      );
    }

    this.changeDetector.markForCheck();
  }
}
